module.exports = __webpack_public_path__ + "img/audi-logo.99c4e50f.png";